module.exports = __webpack_public_path__ + "e234ca57cb39ebee8522dd6171f53f57.png";